module.exports = __webpack_public_path__ + "ycc-6085bcf8c4eca75ba95c87e1b81c13f8.png";